<template>
    <div class="main-content">
        <div class="page-header">
            <h3 class="page-title">Nueva compra</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Compras</a></li>
                <li class="breadcrumb-item active">Nueva compra</li>
            </ol>
        </div>
        <div class="card">
            <div class="card-body">
                <tabs class="tabs-default" :options="{ defaultTabHash: 'compra' }">
                    <tab id="compra" name="Compra">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <label>Fecha</label>
                                        <datepicker :format="format" input-class="form-control" :language="es"
                                            v-model="purchaseDate" />
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <label>Localidad</label>
                                    <multi-select v-model="place" :options="places" :allow-empty="false"
                                        :show-labels="false" :searchable="true" label="name" track-by="id"
                                        placeholder="Seleccione una localidad" @input="resetPlace" />
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label>Proveedor</label>
                                        <multi-select v-model="provider" :options="providers" :allow-empty="false"
                                            :show-labels="false" :searchable="true" label="company" track-by="company"
                                            placeholder="Seleccione un proveedor" @search-change="searchProviders"
                                            :internal-search="false" :loading="isLoadingProvider"
                                            :custom-label="nameWithNit"
                                            @input="calculateHighLighted"
                                            >
                                            <template slot="beforeList">
                                                <button class="btn btn-success btn-lg btn-block"
                                                    @click="openModalProvider">Nuevo Proveedor <i
                                                        class="icon-fa icon-fa-plus" /></button>
                                            </template>
                                        </multi-select>

                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label>Crédito autorizado</label>
                                        <input type="text" :value="mymoney(typeof(provider.credit_limit)!=='undefined'?provider.credit_limit:0)" class="form-control" readonly="true" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label>Documento</label>
                                        <multi-select v-model="document" :options="documents" :allow-empty="false"
                                            :show-labels="false" label="name" track-by="id"
                                            placeholder="Seleccione un documento" :loading="isLoadingDocuments"
                                            @input="getCorrelative(document.name)" />
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label>Serie</label>
                                        <div class="input-group">
                                            <input type="number" class="form-control" v-model.number="correlative"
                                                aria-label="Recipient's username" aria-describedby="basic-addon2">
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" v-tooltip="{
                                            content: 'Obtener correlativo',
                                            classes: ['info'],
                                            targetClasses: ['it-has-a-tooltip'],
                                            offset: 30,
                                            }" :disabled="isLoadingCorrelative" @click="getCorrelative"
                                                    type="button"><i class="icon-fa icon-fa-undo" /></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Productos</label>
                                        <multi-select ref="products" v-model="product" :options="products"
                                            :allow-empty="false" :show-labels="false" :searchable="true"
                                            label="nameProduct" track-by="nameProduct"
                                            placeholder="Seleccione sus productos" @search-change="searchProducts"
                                            :internal-search="false" :loading="isLoadingProducts"
                                            :custom-label="nameWithCode" @close="addProduct">
                                        </multi-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label>Productos</label>
                                        <table-component :data="selectProducts" table-class="table"
                                            :show-filter="false">
                                            <table-column show="code" label="Código" />
                                            <table-column show="nameProduct" label="Producto" />
                                            <table-column show="stock" label="Existencia">
                                                <template slot-scope="row">
                                                    {{myquantity(row['stock'])}}
                                                </template>
                                            </table-column>
                                            <table-column :sortable="false" :filterable="false" show="purchase_price"
                                                label="Precio">
                                                <template slot-scope="row">
                                                    {{mymoney(row['purchase_price'])}}
                                                </template>
                                            </table-column>
                                            <table-column :sortable="false" :filterable="false" label="Cantidad">
                                                <template slot-scope="row">
                                                    <input type="number" class="form-control"
                                                        v-model.number="selectProducts[getIndex(selectProducts,row['id'])].quantity"
                                                        @blur="validateQuantity(getIndex(selectProducts,row['id']))"
                                                        :class="{ 'is-invalid': selectProducts[getIndex(selectProducts,row['id'])].error===true }"
                                                        :ref="'quantity-'+getIndex(selectProducts,row['id'])"
                                                        @keyup.enter="refMultiple('quantity',getIndexPlus(selectProducts,row['id']))" />
                                                </template>
                                            </table-column>
                                            <table-column :sortable="false" :filterable="false" label="Subtotal">
                                                <template slot-scope="row">
                                                    {{mymoney(row['subtotal'])}}
                                                </template>
                                            </table-column>
                                            <table-column :sortable="false" :filterable="false" label="Acciones">
                                                <template slot-scope="row">
                                                    <div class="table__actions">
                                                        <button class="btn btn-danger"
                                                            @click="removeProduct(getIndex(selectProducts,row['id']))"><i
                                                                class="icon-fa icon-fa-trash" />
                                                            Quitar
                                                        </button>
                                                    </div>
                                                </template>
                                            </table-column>
                                            <template slot="tfoot">
                                                <tr>
                                                    <th colspan="6" class="text-right">
                                                        <h6 class="font-weight-bold">Total</h6>
                                                    </th>
                                                    <th>
                                                        <h6 class="font-weight-bold">{{mymoney(total)}}</h6>
                                                    </th>
                                                </tr>
                                            </template>
                                        </table-component>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Comentario</label>
                                        <input class="form-control" v-model="description"
                                            placeholder="Comentario sobre la venta" ref="description"
                                            @keyup.enter="changeRefVue('deliveryDate')">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Fecha de entrega</label>
                                        <datepicker ref="deliveryDate" :format="format" input-class="form-control"
                                            :language="es" v-model="dateDelivery" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab id="pagar" name="Pagar">
                        <div v-if="selectProducts.length>0">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-7">
                                        <tabs class="tabs-default" :options="{ defaultTabHash: 'Efectivo' }">
                                            <tab name="Efectivo"
                                                :is-disabled="payments[getIndexWithName(payments,'Efectivo')].status">
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <label>Pagado</label>
                                                        <masked-input
                                                            v-model="payments[getIndexWithName(payments,'Efectivo')].amountTurned"
                                                            ref="efectivoInput" type="text" class="form-control"
                                                            :mask="mask_quetzal" :guide="false"
                                                            :keep-char-positions="true" :show-mask="true"
                                                            @blur="addAllTypesOfPayments()" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Cambio</label>
                                                        <input
                                                            v-model="payments[getIndexWithName(payments,'Efectivo')].amountPaid"
                                                            type="text" class="form-control" readonly="true" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Cuenta</label>
                                                        <select class="form-control"
                                                            v-model="payments[getIndexWithName(payments,'Efectivo')].account">
                                                            <option
                                                                v-for="item in payments[getIndexWithName(payments,'Efectivo')].accounts"
                                                                :key="item.id" :value="item">
                                                                {{item.name}} / {{mymoney(item.amount)}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Descripción</label>
                                                        <textarea
                                                            v-model="payments[getIndexWithName(payments,'Efectivo')].description"
                                                            rows="5" class="form-control">
                                                    </textarea>
                                                    </div>
                                                </div>
                                            </tab>
                                            <tab name="Cheque"
                                                :is-disabled="payments[getIndexWithName(payments,'Cheque')].status">
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <label>Cantidad</label>
                                                        <masked-input
                                                            v-model="payments[getIndexWithName(payments,'Cheque')].amount"
                                                            ref="efectivoInput" type="text" class="form-control"
                                                            :mask="mask_quetzal" :guide="false"
                                                            :keep-char-positions="true" :show-mask="true"
                                                            @blur="addAllTypesOfPayments()" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Cuenta</label>
                                                        <select class="form-control"
                                                            v-model="payments[getIndexWithName(payments,'Cheque')].account">
                                                            <option
                                                                v-for="item in payments[getIndexWithName(payments,'Cheque')].accounts"
                                                                :key="item.id" :value="item">
                                                                {{item.name}} / {{mymoney(item.amount)}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>No.Cheque</label>
                                                        <input
                                                            v-model="payments[getIndexWithName(payments,'Cheque')].ChequeNumber"
                                                            class="form-control" type="text" />
                                                    </div>
                                                    <bank :item="getIndexWithName(payments,'Cheque')"
                                                        :variable="'ChequeNameBank'" @update-bank="updateBank" />
                                                    <div class="form-group">
                                                        <label>Mismo banco</label>
                                                        <select class="form-control"
                                                            v-model="payments[getIndexWithName(payments,'Cheque')].ChequeSameBank">
                                                            <option value="1">Si</option>
                                                            <option value="0">No</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Descripción</label>
                                                        <textarea
                                                            v-model="payments[getIndexWithName(payments,'Cheque')].description"
                                                            rows="5" class="form-control"></textarea>
                                                    </div>
                                                </div>
                                            </tab>
                                            <tab name="Depósito"
                                                :is-disabled="payments[getIndexWithName(payments,'Depósito')].status">
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <label>Cantidad</label>
                                                        <masked-input
                                                            v-model="payments[getIndexWithName(payments,'Depósito')].amount"
                                                            ref="efectivoInput" type="text" class="form-control"
                                                            :mask="mask_quetzal" :guide="false"
                                                            :keep-char-positions="true" :show-mask="true"
                                                            @blur="addAllTypesOfPayments()" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Cuenta</label>
                                                        <select class="form-control"
                                                            v-model="payments[getIndexWithName(payments,'Depósito')].account">
                                                            <option
                                                                v-for="item in payments[getIndexWithName(payments,'Depósito')].accounts"
                                                                :key="item.id" :value="item">
                                                                {{item.name}} / {{mymoney(item.amount)}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>No.Depósito</label>
                                                        <input
                                                            v-model="payments[getIndexWithName(payments,'Depósito')].DepositNumber"
                                                            class="form-control" type="text" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Descripción</label>
                                                        <textarea
                                                            v-model="payments[getIndexWithName(payments,'Depósito')].description"
                                                            rows="5" class="form-control"></textarea>
                                                    </div>
                                                </div>
                                            </tab>
                                            <tab name="Tarjeta de Crédito/Debito"
                                                :is-disabled="payments[getIndexWithName(payments,'Transferencia')].status">
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <label>Cantidad</label>
                                                        <masked-input
                                                            v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].amount"
                                                            ref="efectivoInput" type="text" class="form-control"
                                                            :mask="mask_quetzal" :guide="false"
                                                            :keep-char-positions="true" :show-mask="true"
                                                            @blur="addAllTypesOfPayments()" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Cuenta</label>
                                                        <select class="form-control"
                                                            v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].account">
                                                            <option
                                                                v-for="item in payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].accounts"
                                                                :key="item.id" :value="item">
                                                                {{item.name}} / {{mymoney(item.amount)}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>No.Transacción</label>
                                                        <input
                                                            v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].CardNumber"
                                                            class="form-control" type="text" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Nombre de tarjeta</label>
                                                        <input
                                                            v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].CardName"
                                                            class="form-control" type="text" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Ultimos 4 dígitos de la tarjeta</label>
                                                        <input
                                                            v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].CardLast4digits"
                                                            class="form-control" type="text" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Descripción</label>
                                                        <textarea
                                                            v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].description"
                                                            rows="5" class="form-control"></textarea>
                                                    </div>
                                                </div>
                                            </tab>
                                            <tab name="Transferencia"
                                                :is-disabled="payments[getIndexWithName(payments,'Transferencia')].status">
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <label>Cantidad</label>
                                                        <masked-input
                                                            v-model="payments[getIndexWithName(payments,'Transferencia')].amount"
                                                            ref="efectivoInput" type="text" class="form-control"
                                                            :mask="mask_quetzal" :guide="false"
                                                            :keep-char-positions="true" :show-mask="true"
                                                            @blur="addAllTypesOfPayments()" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Cuenta</label>
                                                        <select class="form-control"
                                                            v-model="payments[getIndexWithName(payments,'Transferencia')].account">
                                                            <option
                                                                v-for="item in payments[getIndexWithName(payments,'Transferencia')].accounts"
                                                                :key="item.id" :value="item">
                                                                {{item.name}} / {{mymoney(item.amount)}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>No.Transferencia</label>
                                                        <input
                                                            v-model="payments[getIndexWithName(payments,'Transferencia')].TransferNumber"
                                                            class="form-control" type="text" />
                                                    </div>
                                                    <bank :item="getIndexWithName(payments,'Transferencia')"
                                                        :variable="'TransferNameBank'" @update-bank="updateBank" />
                                                    <div class="form-group">
                                                        <label>Mismo banco</label>
                                                        <select class="form-control"
                                                            v-model="payments[getIndexWithName(payments,'Transferencia')].TransferSameBank">
                                                            <option value="1">Si</option>
                                                            <option value="0">No</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Descripción</label>
                                                        <textarea
                                                            v-model="payments[getIndexWithName(payments,'Transferencia')].description"
                                                            rows="5" class="form-control"></textarea>
                                                    </div>
                                                </div>
                                            </tab>
                                            <tab name="Crédito"
                                                :is-disabled="payments[getIndexWithName(payments,'Crédito')].status || typePaymentCredit()">
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <label>Cantidad</label>
                                                        <masked-input
                                                            v-model="payments[getIndexWithName(payments,'Crédito')].amount"
                                                            ref="efectivoInput" type="text" class="form-control"
                                                            :mask="mask_quetzal" :guide="false"
                                                            :keep-char-positions="true" :show-mask="true"
                                                            @blur="addAllTypesOfPayments()" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Cuenta</label>
                                                        <select class="form-control"
                                                            v-model="payments[getIndexWithName(payments,'Crédito')].account">
                                                            <option
                                                                v-for="item in payments[getIndexWithName(payments,'Crédito')].accounts"
                                                                :key="item.id" :value="item">
                                                                {{item.name}} / {{mymoney(item.amount)}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Fecha de cobro</label>
                                                        <datepicker
                                                            v-model="payments[getIndexWithName(payments,'Crédito')].CreditDateLimit"
                                                            :format="format" input-class="form-control"
                                                            :disabled-dates="highlighted"
                                                            :language="es" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Descripción</label>
                                                        <textarea
                                                            v-model="payments[getIndexWithName(payments,'Crédito')].description"
                                                            rows="5" class="form-control"></textarea>
                                                    </div>
                                                </div>
                                            </tab>
                                        </tabs>
                                    </div>
                                    <div class="col-lg-5">
                                        <div class="row">
                                            <div class="container">
                                                <div class="row justify-content-center">
                                                    <h6>Proveedor</h6>
                                                </div>
                                            </div>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td class="font-weight-bold">Proveedor: </td>
                                                        <td>{{typeof(provider.company)!=='undefined'?provider.company:'Seleccione un proveedor'}}</td>
                                                    </tr>
                                                    <tr>    
                                                        <td class="font-weight-bold">Crédito autorizado: </td>
                                                        <td>{{mymoney(typeof(provider.credit_limit)!=='undefined'?provider.credit_limit:0)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="font-weight-bold">Límete de días: </td>
                                                        <td>{{typeof(provider.day_limit)!=='undefined'?provider.day_limit:'No aplica'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div class="container">
                                                <div class="row justify-content-center">
                                                    <h6>Pagos</h6>
                                                </div>
                                            </div>
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th>Tipo de pago</th>
                                                        <th>Cantidad</th>
                                                        <th>Cuenta</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="payment in paymentWithAmount" :key="payment.id">
                                                        <td>{{payment.name}}</td>
                                                        <td>{{payment.amount}}</td>
                                                        <td v-if="payment.account!=0">{{payment.account.name}}</td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td class="font-weight-bold">Monto total</td>
                                                        <td colspan="2">{{mymoney(totalChequer)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="font-weight-bold">Total de la venta</td>
                                                        <td colspan="2">{{mymoney(total)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="font-weight-bold"
                                                            :class="subtraction(total,totalChequer)===0 ? 'bg-success':'bg-danger'">
                                                            Pendiente</td>
                                                        <td :class="subtraction(total,totalChequer)===0 ? 'bg-success':'bg-danger'"
                                                            colspan="2">
                                                            {{mymoney(subtraction(total,totalChequer))}}</td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <label>&nbsp;</label>
                                            <button slot="button" class="btn btn-block btn-theme ladda-button"
                                                data-style="expand-right" ref="buttonSave" @keyup.enter="saveAll"
                                                @click="saveAll">Guardar compra</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body" v-else>
                            <h1 class="text-justify">No hay productos que pagar</h1>
                        </div>
                    </tab>
                </tabs>
            </div>
        </div>
        <sweet-modal ref="modal_provider" title="Nuevo proveedor" @close="closeModalProvider" hide-close-button
            blocking>
            <!-- BEGIN FORM -->
            <div class="card-body">
                <div class="form-group">
                    <label>Nit del proveedor</label>
                    <input class="form-control" placeholder="C/F" :class="{ 'is-invalid': $v.providerNit.$error }"
                        v-model.trim="providerNit" @blur="$v.providerNit.$touch()">
                    <div v-if="$v.providerNit.$error">
                        <span v-if="!$v.providerNit.nit" class="help-block help-block-error">El número de nit no es
                            válido.</span>
                    </div>
                </div>
                <div class="form-group">
                    <label>Nombre contacto</label>
                    <input class="form-control" v-model.trim="providerName">
                </div>
                <div class="form-group">
                    <label>Empresa</label>
                    <input class="form-control" :class="{ 'is-invalid': $v.providerCompany.$error }"
                        v-model.trim="providerCompany" @blur="$v.providerCompany.$touch()">
                    <div v-if="$v.providerCompany.$error">
                        <span v-if="!$v.providerCompany.required" class="help-block help-block-error">El nombre de la
                            empresa es requerida.</span>
                    </div>
                </div>
                <div class="form-group">
                    <label>Dirección</label>
                    <input class="form-control" placeholder="Ciudad" v-model.trim="providerAddress">
                </div>
                <div class="form-group">
                    <label>Teléfono</label>
                    <masked-input class="form-control" v-model="providerTelephone"
                        :mask="[ /\d/,/\d/, /\d/, /\d/, '-',/\d/, /\d/, /\d/, /\d/]" :guide="false"
                        :keep-char-positions="true" :show-mask="true" />
                </div>
            </div>
            <button slot="button" type="button" class="btn btn-danger"
                @click="$refs.modal_provider.close()">Cancelar</button>
            <button slot="button" type="button" class="btn btn-primary ladda-button" data-style="expand-right"
                @click="saveProvider">Guardar</button>
            <!-- END FORM -->
        </sweet-modal>
    </div>
</template>
<script>
    import { Tabs, Tab } from 'vue-tabs-component'
    import Datepicker from 'vuejs-datepicker'
    import { en, es } from 'vuejs-datepicker/dist/locale'
    import Multiselect from 'vue-multiselect'
    import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
    import ladda from "ladda";
    import { required, between } from "vuelidate/lib/validators";
    import { xelacode } from '../../../helpers/xelacode'
    import MaskedInput from 'vue-text-mask'
    import createNumberMask from 'text-mask-addons/dist/createNumberMask'
    import { TableComponent, TableColumn } from "vue-table-component";
    import Bank from '../utils/Bank';
    // VALIDACION DPI
    let nit = (value) => xelacode.nitIsValid(value);
    export default {
        components: {
            'tabs': Tabs,
            'tab': Tab,
            Datepicker,
            'multi-select': Multiselect,
            SweetModal,
            SweetModalTab,
            'masked-input': MaskedInput,
            TableComponent,
            TableColumn,
            'bank': Bank
        },
        data() {
            return {
                highlighted:{},
                format: 'dd/MM/yyyy',
                en: en,
                es: es,
                purchaseDate: new Date().toISOString().slice(0, 10),
                mask_quetzal: createNumberMask({
                    prefix: 'Q ',
                    suffix: '',
                    includeThousandsSeparator: true,
                    thousandsSeparatorSymbol: ',',
                    allowDecimal: true,
                    decimalSymbol: '.',
                    decimalLimit: 2, // how many digits allowed after the decimal
                    integerLimit: 10, // limit length of integer numbers
                    allowNegative: false,
                    allowLeadingZeroes: false,
                }),
                place: {},
                places: [],
                provider: '',
                providers: [],
                isLoadingProvider: false,
                providerNit: '',
                providerCompany: '',
                providerAddress: '',
                providerTelephone: '',
                providerName: '',
                state: 1,
                isLoadingDocuments: false,
                document: '',
                documents: [],
                isLoadingCorrelative: false,
                correlative: '',
                product: '',
                products: [],
                isLoadingProducts: false,
                selectProducts: [],
                total: 0,
                description: '',
                dateDelivery: new Date().toISOString().slice(0, 10),
                user: '',
                payments: [],
                totalChequer: 0,
            }
        },
        computed: {
            paymentWithAmount() {
                return this.payments.filter(x => x.amount != "");
            }
        },
        validations: {
            providerNit: {
                nit
            },
            providerCompany: {
                required
            },
        },
        methods: {
            // METHOD REF TI INPUT VUE
            changeRefVue(nameRef) {
                this.$refs[nameRef].$el.focus();
            },
            // METHOD TO REF
            changeRef(nameRef) {
                this.$refs[nameRef].focus();
            },
            changeRefInput(nameRef) {
                this.$refs[nameRef].focus();
            },
            refMultiple(input, item) {
                let inputLength = this.selectProducts.length - 1;
                if (item > inputLength) {
                    this.changeRef('description');
                } else {
                    this.changeRefInput(`${input}-${item}`);
                }
            },
            // METHOD NUMBERS TWO DECIMAL
            parseDecimal(value) {
                return parseFloat(this.parseDecimalFixed(value));
            },
            parseDecimalFixed(value) {
                return parseFloat(value).toFixed(2);
            },
            // METHOD QUETZALES
            mymoney(value) {
                return xelacode.money(parseFloat(value));
            },
            myquantity(value) {
                return xelacode.quantity(value);
            },
            nameWithNit({ company, nit }) {
                return `${nit}|${company}`;
            },
            openModalProvider() {
                this.state = 1;
                this.$v.$reset();
                this.$refs.modal_provider.open();
            },
            closeModalProvider() {
                this.state = 0;
                this.providerNit = '';
                this.providerCompany = '';
                this.providerAddress = '';
                this.providerTelephone = '';
                this.providerName = '';
            },
            selectPlaces(id) {
                let vm = this;
                var url = '/api/admin/place/getSelect';
                axios.get(url)
                    .then(function (response) {
                        var respuesta = response.data;
                        vm.places = respuesta.place;
                        vm.place = vm.places.find(x => x.id === id);
                        vm.searchProducts('A');
                        vm.getPayments();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            searchProviders(filter) {
                let vm = this;
                var url = `/api/purchase/getProviders?filter=${filter}`;
                this.isLoadingProvider = true;
                axios.get(url)
                    .then(function (response) {
                        vm.providers = response.data.data;
                        vm.isLoadingProvider = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        vm.isLoadingProvider = false;
                    });
                // console.log(this.client);
            },
            saveProvider() {
                var l = ladda.create(document.querySelector(".ladda-button"));
                let me = this;
                if (this.$v.$invalid) {
                    toastr.error("Revise los campos", "Error");
                } else {
                    l.start();
                    axios.post("/api/purchase/newProvider", {
                        nit: me.providerNit,
                        company: me.providerCompany,
                        address: me.providerAddress,
                        number: me.providerTelephone,
                        name: me.providerName
                    })
                        .then(function (response) {
                            toastr.success(response.data.message, "Listo");
                            me.provider = {
                                id: response.data.id,
                                company: response.data.company,
                                nit: response.data.nit,
                            };
                            l.stop();
                            me.closeModalProvider();
                            me.$refs.modal_provider.close();
                        })
                        .catch(function (error) {
                            l.stop();
                            toastr.error(error.response.data.message, "Error");
                        });
                }
            },
            getDocuments() {
                let me = this;
                var url = `/api/purchase/getDocument`;
                this.isLoadingDocuments = true;
                axios.get(url)
                    .then(function (response) {
                        me.documents = response.data;
                        me.isLoadingDocuments = false;
                        var myDocument = me.documents.filter(x => x.name == 'Compra');
                        me.document = myDocument[0];
                        me.getCorrelative(me.document.name);
                    })
                    .catch(function (error) {
                        console.log(error);
                        me.isLoadingDocuments = false;
                    });
            },
            getCorrelative(name) {
                if (name === null || name === '' || typeof (name) === "undefined") {
                    return;
                }
                let me = this;
                var url = `/api/purchase/getCorrelative?name=${name}`;
                this.isLoadingCorrelative = true;
                axios.get(url).then(function (response) {
                    me.correlative = response.data.correlative;
                    me.isLoadingCorrelative = false;
                })
                    .catch(function (error) {
                        console.log(error);
                        me.isLoadingCorrelative = false;
                    });
            },
            nameWithCode({ nameProduct, code }) {
                return `${code} | ${nameProduct}`;
            },
            searchProducts(filter) {
                let me = this;
                var url = `/api/purchase/getProducts?place=${this.place.id}&filter=${filter}`;
                this.isLoadingProducts = true;
                axios.get(url)
                    .then(function (response) {
                        me.products = response.data.data;
                        me.isLoadingProducts = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        me.isLoadingProducts = false;
                    });
            },
            getIndex(list, id) {
                return list.findIndex((e) => e.id == id)
            },
            addProduct() {
                if (typeof (this.selectProducts.find(x => x.id === this.product.id)) !== "undefined") {
                    toastr.error("El producto ya esta agregado", "Error");
                    this.product = '';
                    return;
                } else if (this.product === [] || this.product === '' || this.product === null) {
                    toastr.error("Seleccione un producto", "Error");
                    this.product = '';
                    return;
                }
                this.selectProducts.push(this.product);
                this.calculateSubtotal(this.selectProducts.length - 1);
                this.product = '';
                // this.changeRefVue('products');
            },
            validateQuantity(item) {
                if (typeof (this.selectProducts[item].quantity) != "undefined") {
                    if (this.selectProducts[item].quantity < 1) {
                        this.selectProducts[item].quantity = 1;
                        toastr.error("La cantidad debe ser al menos 1", "Error");
                        this.refMultiple('quantity', item);
                    }
                    this.calculateSubtotal(item);
                }
            },
            calculateSubtotal(item) {
                this.selectProducts[item].subtotal = parseFloat(this.selectProducts[item].quantity) * parseFloat(this.selectProducts[item].purchase_price);
                this.calculateTotal();
            },
            calculateTotal() {
                let me = this;
                this.total = 0;
                this.selectProducts.forEach(item => {
                    me.total = me.parseDecimal(me.total) + me.parseDecimal(item.subtotal);
                });
            },
            removeProduct(item) {
                this.selectProducts.splice(item, 1);
                this.calculateTotal();
            },
            getIndexPlus(list, id) {
                return list.findIndex((e) => e.id == id) + 1;
            },
            resetPlace(value) {
                this.selectProducts = [];
                this.products = [];
                this.searchProducts('A');
                toastr.error('Si cambia de sucursal los productos seleccionados, se quitaran', 'Error')
            },
            getUser() {
                let me = this;
                axios.get('/api/purchase/getUser')
                    .then((response) => {
                        me.user = response.data;
                        me.selectPlaces(me.user.placeId);
                    }).catch((error) => {
                        console.log(error);
                    })
            },
            // END TAB PURCHASE
            // BEGIN TAB PURCHASE
            getAccounts() {
                let me = this;
                me.payments.forEach((item, index) => {
                    var url = `/api/purchase/getAccounts?place=${me.place.id}&payment=${item.name}`;
                    axios.get(url).then(function (response) {
                        me.payments[index].accounts = response.data;
                        if (me.payments[index].accounts === 0)
                            me.payments[index].accounts = [];
                    })
                        .catch(function (error) {
                            console.log(error);
                        });
                });
            },
            getPayments() {
                let me = this;
                var url = `/api/purchase/getPayments`;
                axios.get(url).then(function (response) {
                    me.payments = response.data;
                    me.getAccounts();
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getIndexWithName(list, name) {
                return list.findIndex(x => x.name === name);
            },
            updateBank(value, item, variable) {
                this.payments[item][variable] = value;
            },
            subtraction(A, B) {
                return this.parseDecimal(this.parseDecimal(A) - this.parseDecimal(B))
            },
            saveAll(){
                let me=this;
                let validate=false;
                me.payments.forEach((item,index) => {
                    if(item.name==="Efectivo"){
                        if(item.amountTurned!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en efectivo','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Cheque"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en cheque','Error')
                                validate=true;
                                return;
                            }
                            else if(item.ChequeNumber==""){
                                toastr.error('Ingrese un número de cheque','Error')
                                validate=true;
                                return;
                            }
                            else if(item.ChequeNameBank==""){
                                toastr.error('Seleccione un banco en crédito','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Depósito"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en depósito','Error')
                                validate=true;
                                return;
                            }
                            else if(item.DepositNumber==""){
                                toastr.error('Ingrese un número de transacción en depósito','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Tarjeta de Crédito/Debito"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en tarjeta de Crédito/Debito','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardNumber==""){
                                toastr.error('Ingrese el número de transacción en tarjeta','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardName==""){
                                toastr.error('Ingrese el nombre del propietario en tarjeta','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardLast4digits==""){
                                toastr.error('Ingrese lo últimos 4 dígitos en tarjeta','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Tarjeta de Crédito/Debito"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en tarjeta de Crédito/Debito','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardName==""){
                                toastr.error('Ingrese el nombre del propietario en tarjeta','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardNumber==""){
                                toastr.error('Ingrese el número de transacción en tarjeta','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardLast4digits==""){
                                toastr.error('Ingrese lo últimos 4 dígitos en tarjeta','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Transferencia"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en transferencia','Error')
                                validate=true;
                                return;
                            }
                            else if(item.TransferNumber==""){
                                toastr.error('Ingrese el número de transacción en transferencia','Error')
                                validate=true;
                                return;
                            }
                            else if(item.TransferNameBank==""){
                                toastr.error('Seleccione un banco en transferencia','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Crédito"){
                        if(item.amount!=""){
                            if(me.parseDecimal(me.converMaskToNumber(item.amount))>me.provider.credit_limit){
                                toastr.error('El crédito es insuficiente','Error')
                                validate=true;
                                return;
                            }
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en crédito','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CreditDateLimit==""){
                                toastr.error('Selecciona una fecha de pago en crédito','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                });
                if(validate===true){
                    return;
                }
                if(this.provider===''){
                    toastr.error('Para pagar la compra, seleccione a un proveedor','Error')
                    validate=true;
                }
                if(validate===true){
                    return; 
                }
                if(this.subtraction(this.total,this.totalChequer)!=0){
                    toastr.error('Para pagar la compra la cantidad pendiente deber ser igual a 0','Error')
                    validate=true;
                }
                if(validate===true){
                    return; 
                }
                me.payments.forEach((element,index) => {
                    if(element.amount!=""){
                        if(String(element.amount).includes('Q'))
                            me.payments[index].amountString=me.parseDecimal(me.converMaskToNumber(element.amount));
                    }
                });
                if(this.payments[this.getIndexWithName(this.payments,'Crédito')].amount!="")
                    this.payments[this.getIndexWithName(this.payments,'Crédito')].CreditDateLimit=this.updateDate(this.payments[this.getIndexWithName(this.payments,'Crédito')].CreditDateLimit);
                var l = ladda.create(document.querySelector(".ladda-button"));
                    l.start();
                    axios.post('/api/purchase/store',{
                        purchase_date:me.purchaseDate,
                        delivery_date:me.dateDelivery,
                        description:me.description,
                        document_number:me.correlative,
                        total:me.total,
                        idbuyer:me.user.id,
                        idprovider:me.provider.id,
                        user_created:me.user.id,
                        user_updated:me.user.id,
                        iddocument:me.document.id,
                        idplace:me.place.id,
                        products:JSON.stringify(me.selectProducts),
                        payments: JSON.stringify(me.payments),
                    }).then((response)=>{
                        toastr.success(response.data.message, "Listo");
                        me.$router.push({name:'CompraLista'})
                        l.stop();
                    }).catch((error)=>{
                        toastr.error(error.response.data.message, "Error");
                        l.stop();
                    });
                
            },
            updateDate(value){
                return new Date(value).toISOString().slice(0,10);
            },
            addAllTypesOfPayments() {
                this.totalChequer = 0;
                let me = this;
                var listTemporary = [];
                var totalWithOutEfectivo=0;
                this.payments.forEach((payment, index) => {
                    if (payment.status === 0) {
                        var numberTemporary = 0;
                        if (payment.amount !== ""&&payment.name!="Efectivo"){
                            numberTemporary = me.parseDecimal(me.converMaskToNumber(payment.amount));
                            totalWithOutEfectivo+=numberTemporary;
                        }else if(payment.name==="Efectivo"){
                            var amountTurned=me.parseDecimal(me.converMaskToNumber(payment.amountTurned));
                            if(isNaN(amountTurned))
                                amountTurned=0;
                            var amountPaid=me.subtraction(amountTurned,me.subtraction(me.total,totalWithOutEfectivo));
                            if(amountPaid<0){
                                me.payments[index].amountPaid=me.mymoney(0);
                                numberTemporary=amountTurned;
                                me.payments[index].amount=me.mymoney(numberTemporary);
                            }else{
                                me.payments[index].amountPaid=me.mymoney(amountPaid);
                                numberTemporary=me.subtraction(amountTurned,amountPaid);
                                me.payments[index].amount=me.mymoney(numberTemporary);
                            }
                        }    
                        // console.log(numberTemporary);
                        me.totalChequer += numberTemporary;
                        listTemporary.push(index);
                        if (me.totalChequer >= me.parseDecimal(me.total)) {
                            me.payments.forEach((item, i) => {
                                if (item.amount === "" || me.parseDecimal(me.converMaskToNumber(item.amount)) <= 0)
                                        me.payments[i].status = 1;
                            });
                            return;
                        } else if (numberTemporary < me.parseDecimal(me.total) && me.totalChequer < me.parseDecimal(me.total)) {
                            me.payments.forEach((item, i) => {
                                if (item.name !== payment.name) {
                                    me.payments[i].status = 0;
                                }
                            });
                            return;
                        }
                    }
                });
            },
            converMaskToNumber(value) {
                var myNumber = "";
                for (var i = 0; i < value.length; i += 1) {
                    if (value.charAt(i) === 'Q' || value.charAt(i) === ',' || value.charAt(i) === ' ') {
                        continue;
                    } else {
                        myNumber += value.charAt(i);
                    }
                }
                return parseFloat(myNumber).toFixed(2);
            },
            typePaymentCredit(){
                if(typeof(this.provider.credit_limit)!="undefined"){
                    if(this.provider.credit_limit>0)
                        return 0;
                    else
                        return 1;
                }
                return 1;
            },
            calculateHighLighted(value){
                this.payments[this.getIndexWithName(this.payments,'Crédito')].CreditDateLimit="";
                let day_to=new Date(this.purchaseDate);

                let days = 1000 * 60 * 60 * 24 * (value.day_limit+1);
                let total=day_to.getTime()+days;
                let to=new Date(total);
                
                this.highlighted={
                    to:day_to,
                    from: to
                };
            }
            // END TAB PURCHASE
            
        },
        mounted() {
            this.getUser();
            this.getDocuments();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/purchase/Purchase.vue